import { render, staticRenderFns } from "./WeightModal.vue?vue&type=template&id=7028a030&scoped=true"
import script from "./WeightModal.vue?vue&type=script&lang=js"
export * from "./WeightModal.vue?vue&type=script&lang=js"
import style0 from "./WeightModal.vue?vue&type=style&index=0&id=7028a030&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7028a030",
  null
  
)

export default component.exports